'use strict';

angular.module('internal.vehicles')
    .directive('internalVehicleNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'vehicles/components/vehicle-navigation/vehicle-navigation.html',
            replace: true,
            controller: ('InternalNavigation', ['$scope', 'Enterprise', function ($scope, Enterprise) {
                $scope.inspectionsModuleOn = false;
                Enterprise.get().then(function (enterprise) {
                    if (enterprise != null) {
                        $scope.inspectionsModuleOn = (enterprise.inspections_module == null ? false : enterprise.inspections_module);
                    }
                })
            }])
        };
    }])
;